import * as API from "middleware/api";
import * as configUtils from "util/config";
import { format } from "date-fns";

export const downloadStatement = (idStatement) =>
    API.executeWithAccessToken("/account.get.extract", { id_extract: idStatement });

export const editMovementNote = (idProduct, idStatement, note) =>
    API.executeWithAccessToken("/notes.editStatementNote", { idProduct, idStatement, note });

export const listAccounts = () => API.executeWithAccessToken("/accounts.list");

export const listAllAccounts = () => API.executeWithAccessToken("/accounts.list.all");

export const listAccountsCbu = () => API.executeWithAccessToken("/accounts.list.with.cbu");

export const validateDateMiddleware = (dateProcess) =>
    API.executeWithAccessToken("/misc.get.firstBusinessDay", { dateProcess });

export const listMovements = (idAccount, filters) => {
    const { dateFrom, dateTo, parentFilter } = filters;
    const { operationNumber, minAmount, maxAmount, detail, cbu = "" } = filters;

    const path = parentFilter === "lastMonth" ? "/accounts.listLastMovements" : "/accounts.listPendingMovements";

    return API.executeWithAccessToken(path, {
        idAccount,
        startDate: dateFrom,
        endDate: dateTo,
        operationNumber,
        minAmount,
        maxAmount,
        detail,
        cbu,
    });
};

export const listStatements = (year, month, accountId) =>
    API.executeWithAccessToken("/account.list.extracts", {
        year,
        month,
        accountId,
    });

// eslint-disable-next-line no-unused-vars
// export const listStatements = (idAccount) => listStatementMock();

export const readAccount = (idAccount, getPendingBalance = false) =>
    /*
    if (configUtils.getBoolean("ms.account.enabled", false)) {
        return restAPI.getWithAccessToken(`/api/accounts/v1/accounts/${idAccount}`);
    }
    */
    API.executeWithAccessToken("/accounts.read", { idAccount, getPendingBalance });

export const downloadHistoricalBalances = (idAccount, date, fileFormat) =>
    API.executeWithAccessToken("/accounts.downloadHistoricalBalances", {
        idAccount,
        date,
        format: fileFormat,
    });

export const downloadMovements = (idAccount, { dateFrom, dateTo, ...filters }, fileFormat) =>
    API.executeWithAccessToken("/accounts.downloadMovements", {
        idAccount,
        format: fileFormat,
        dateFrom: format(
            dateFrom ||
                new Date(
                    new Date().setDate(
                        new Date().getDate() - configUtils.getInteger("account.movement.defaultDays", 90),
                    ),
                ),
            "YYYY-MM-DD",
        ),
        dateTo: format(dateTo || new Date(), "YYYY-MM-DD"),
        ...filters,
    });

export const downloadPendingMovements = (idAccount, dateFrom, dateTo, fileFormat) =>
    API.executeWithAccessToken("/accounts.downloadPendingMovements", {
        idAccount,
        startDate:
            dateFrom ||
            new Date(
                new Date().setDate(new Date().getDate() - configUtils.getInteger("account.movement.defaultDays", 90)),
            ),
        endDate: dateTo || new Date(),
        format: fileFormat,
    });

export const downloadAccounts = (fileFormat) =>
    API.executeWithAccessToken("/accounts.downloadAccounts", {
        format: fileFormat,
    });

export const downloadMovement = (movement, fileFormat) =>
    API.executeWithAccessToken("/accounts.downloadDetailMovement", {
        movement,
        format: fileFormat,
    });

export const readQr = (idAccount) => API.executeWithAccessToken("/accounts.readQr", { idAccount });

export const agreements = (idAccount, date) =>
    API.executeWithAccessToken("/agreements.list", {
        idAccount,
        date,
    });

export const listCredentialsGroups = (params) =>
    API.executeWithAccessToken("/core.listTransactionCredentialsGroups", params);

export const agreementAvailableAmountRequest = () => API.executeWithAccessToken("/agreement.available.amount");

export const agreementTaxRequest = (params) => API.executeWithAccessToken("/agreement.rate", params);

export const newAgreementRequest = (params) => API.executeWithAccessToken("/request.agreement.send", params);

export const accountRequest = (params) => API.executeWithAccessToken("/request.account.send", params);
export const accountCheckbookRequest = (params) =>
    API.executeWithAccessToken("/request.accountsCheckbook.send", params);

export const signAccountTransaction = (params) => API.executeWithAccessToken("/core.signTransaction", params);

export const historicalBalances = (idAccount, date) =>
    API.executeWithAccessToken("/accounts.historicalBalances", {
        idAccount,
        date,
    });

export const changeCbuAlias = (idAccount, cbu, newAlias, password) =>
    API.executeWithAccessToken("/accounts.modifyCbuAlias", {
        idAccount,
        cbu,
        newAlias,
        _password: password,
    });

export const cashOutPreview = (params) => API.executeWithAccessToken("/cashout.preview", params);

export const cashOutSend = (params) => API.executeWithAccessToken("/cashout.send", params);

export const directDebitDocumentUpload = (params) => API.executeWithAccessToken("/directdebit.document.upload", params);

export const directDebitDocumentDelete = (params) => API.executeWithAccessToken("/directdebit.document.delete", params);

export const downloadTemplate = (params) => API.executeWithAccessToken("/files.download.template", { ...params });

export const directDebitSend = (params) => API.executeWithAccessToken("/directdebit.send", params);

export const directDebitListDownloads = (params) => API.executeWithAccessToken("/directdebit.downloads.list", params);
export const directDebitGetDownload = (params) => API.executeWithAccessToken("/directdebit.downloads.get", params);
